import React from 'react'
import { Helmet } from 'react-helmet'
import styles from 'modules/MediaPlanner/MediaPlanner.module.scss'
import { Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import Breadcrumbs from 'components/Breadcrumbs'
import { ROUTES } from 'constants/routes'
import { useHistory, useRouteMatch } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

import { Table } from 'modules/MediaPlanner/subcomponents/Table'
import PageHeader from 'components/PageHeader'
import ydConfig from 'modules/Forms/MediaPlanner/yd/config'
import vkAdsConfig from 'modules/Forms/MediaPlanner/vk-ads/config'
import YdForm from 'modules/Forms/MediaPlanner/yd'
import VkAdsForm from 'modules/Forms/MediaPlanner/vk-ads'

const CONFIG = {
  yd: {
    config: ydConfig,
    benchmark: 'yandex-benchmark',
    Form: YdForm,
  },
  'vk-ads': {
    config: vkAdsConfig,
    benchmark: 'vk-benchmark',
    Form: VkAdsForm,
  },
}

const MediaPlanner = () => {
  const { params: { networkType } = {} } = useRouteMatch()
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const history = useHistory()

  const { benchmark = null, config, Form } = CONFIG?.[networkType] ?? {}

  if (!benchmark) {
    history.push(pathGen(ROUTES.SERVICES))
    return null
  }

  return (
    <>
      <Helmet defer={false}>
        <title>{t('media_planner::title')}</title>
      </Helmet>

      <div className={styles['media-planner']}>
        <Breadcrumbs
          links={[
            {
              title: t('services::heading'),
              to: pathGen(ROUTES.SERVICES),
            },
            {
              title: t(`services::networks.${networkType}`),
              to: pathGen(ROUTES.SERVICES_NETWORK, {
                networkType,
              }),
            },
          ]}
        />

        <PageHeader className={'margin-bottom-16'}>{t('media_planner::heading')}</PageHeader>
        <Typography
          className={'margin-bottom-24'}
          color={'Label-Secondary'}
          variant={'Body-2'}
          component={'p'}
          noMargin
        >
          {t('media_planner::summary')}
        </Typography>
        <Form
          config={config}
          benchmark={benchmark}
          className={'margin-bottom-40'}
        />
        <Table
          config={config}
          benchmark={benchmark}
        />
      </div>
    </>
  )
}

export default MediaPlanner
